import React, { useCallback, useState } from "react";
import { Modal } from "react-bootstrap";
import { FaHandHoldingUsd, FaTimes } from "react-icons/fa";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/payroll.css";
import COLORS from "../resources/colors/COLORS";

const HEADER_GRADIENT = `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 55%, ${COLORS.primary_color_shade9} 100%)`;

//Created By Cursor
const formatMoney = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0";
  return n.toLocaleString("en-IN", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  });
};

//Created By Cursor — mirrors bottomsheet_confirmation_fee_settlement
const ModalSettlementConfirmation = ({
  action,
  action2,
  netPayableAmount = 0,
}) => {
  const [show, setShow] = useState(true);

  const handleClose = useCallback(() => {
    setShow(false);
    if (typeof action === "function") action();
  }, [action]);

  const handleSubmit = useCallback(() => {
    setShow(false);
    if (typeof action2 === "function") action2();
  }, [action2]);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      animation={false}
      dialogClassName="msc-dialog"
      contentClassName="msc-content"
      aria-labelledby="msc-title"
    >
      <div className="msc-hero" style={{ background: HEADER_GRADIENT }}>
        <button
          type="button"
          className="msc-close"
          onClick={handleClose}
          aria-label="Close"
        >
          <FaTimes aria-hidden />
        </button>
        <div className="msc-hero__icon" aria-hidden>
          <FaHandHoldingUsd />
        </div>
        <h2 id="msc-title" className="msc-hero__title">
          Confirm Settlement
        </h2>
        <p className="msc-hero__sub">
          Review the amount before submitting this settlement request.
        </p>
      </div>

      <div className="msc-body">
        <div className="msc-amount-ring" aria-label="Settlement amount">
          <span className="msc-amount-ring__label">Settle amount</span>
          <span className="msc-amount-ring__value">
            ₹{formatMoney(netPayableAmount)}
          </span>
        </div>
        <p className="msc-hint">
          Selected fee dues will be settled for the student once you confirm.
        </p>
      </div>

      <div className="msc-footer">
        <button
          type="button"
          className="msc-btn msc-btn--ghost"
          onClick={handleClose}
        >
          Cancel
        </button>
        <button
          type="button"
          className="msc-btn msc-btn--primary"
          onClick={handleSubmit}
        >
          <FaHandHoldingUsd aria-hidden />
          Confirm &amp; Submit
        </button>
      </div>
    </Modal>
  );
};

export default ModalSettlementConfirmation;
